module.exports = __webpack_public_path__ + "static/img/4.2fa861ab.png";